import { NavLink, useLocation } from "react-router-dom";
import { House, Flag, Trophy, ChartLineUp, User } from "@phosphor-icons/react";

const items = [
  { to: "/app", label: "Home", icon: House, testid: "nav-home" },
  { to: "/app/courses", label: "Courses", icon: Flag, testid: "nav-courses" },
  { to: "/app/leagues", label: "Leagues", icon: Trophy, testid: "nav-leagues" },
  { to: "/app/stats", label: "Stats", icon: ChartLineUp, testid: "nav-stats" },
  { to: "/app/profile", label: "Profile", icon: User, testid: "nav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  // Hide bottom nav inside active round
  if (pathname.startsWith("/app/round/")) return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 pointer-events-none"
    >
      <div className="max-w-md mx-auto px-3 pb-3 pt-1 pointer-events-auto">
        <div
          className="px-2 py-2 rounded-3xl bg-white border flex justify-around items-center shadow-[0_10px_40px_-10px_rgba(20,61,47,0.25)]"
          style={{ borderColor: "var(--border-default)" }}
        >
          {items.map((it) => {
            const Icon = it.icon;
            return (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/app"}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center px-3 py-2 rounded-2xl transition-all ${
                    isActive ? "bg-[var(--primary)] text-white" : "text-[var(--text-secondary)] hover:text-[var(--primary)]"
                  }`
                }
              >
                <Icon size={22} weight="bold" />
                <span className="text-[10px] mt-1 font-semibold tracking-wide uppercase font-heading">{it.label}</span>
              </NavLink>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
